// Suosikit (docs/features/menu-favorites.md): an admin's pinned menu items, shown at the top of
// the sidebar. A favourite is a route `path` from routes.js, without the layout
// ('/calendar', '/coaching/groups'). The user's own list lives in their prefs doc
// (users/{uid}/venuemanager/{cid}.favorites); Cintoia can seed a venue default in
// venuemanagerfeatures/{cid}.favorites.

const cleanList = (list) => (Array.isArray(list) ? list.filter((p) => typeof p === 'string' && p) : [])

// The user's list once they have one - even an empty one, which means they cleared it - and the
// venue default before that.
export const effectiveFavorites = (userFavorites, venueDefault) =>
  Array.isArray(userFavorites) ? cleanList(userFavorites) : cleanList(venueDefault)

export const isFavorite = (list, path) => cleanList(list).includes(path)

export const toggleFavorite = (list, path) => {
  const current = cleanList(list)
  return current.includes(path) ? current.filter((p) => p !== path) : [...current, path]
}

export const moveFavorite = (list, from, to) => {
  const next = cleanList(list).slice()
  if (from < 0 || from >= next.length || to < 0 || to >= next.length || from === to) return next
  const [item] = next.splice(from, 1)
  next.splice(to, 0, item)
  return next
}

// The favourites as menu items, in list order. Top-level routes and collapse sub-items are both
// candidates; a route the menu would not show (isShown) is skipped, and so is anything
// routes.js no longer has. A sub-item borrows its group's icon and names the group.
export const resolveFavorites = (routes, list, isShown = () => true) => {
  const byPath = {}
  const walk = (items, parent) => {
    ;(items || []).forEach((r) => {
      if (!r || r.divider || r.redirect) return
      if (!isShown(r)) return
      if (r.collapse) {
        walk(r.views, r)
        return
      }
      if (!r.path || byPath[r.path]) return
      byPath[r.path] = {
        path: r.path,
        name: r.name,
        layout: r.layout,
        symbol: r.symbol || (parent && parent.symbol),
        icon: r.icon || (parent && parent.icon),
        iconcomponent: r.iconcomponent || (parent && parent.iconcomponent),
        parentName: parent ? parent.name : null,
        badge: r.badge,
        beta: r.beta,
      }
    })
  }
  walk(routes, null)
  return cleanList(list)
    .map((path) => byPath[path])
    .filter(Boolean)
}
